import {
  availableBarsRestaurantsJobTypes,
  availableCastingJobTypes,
  availableEventSupportJobTypes,
  availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

export default function () {
  return {
    allAvailableJobTypes: [
      ...availableCastingJobTypes,
      ...availableMasterOfCeremoniesJobTypes,
      ...availableEventSupportJobTypes,
      ...availableBarsRestaurantsJobTypes
    ],
  }
}
